<template>
    <div class="subtabs" :class="setTabFixed ? '' : ''" >
                    <div class="mdc-tab-bar main-tabs" role="tablist" ref="degreeViewTab" >
                        <div class="mdc-tab-scroller ">
                            <div class="mdc-tab-scroller__scroll-area">
                                <div class="mdc-tab-scroller__scroll-content justify-content-center">

                                    <button class="mdc-tab mdc-tab--active" role="tab" aria-selected="true" tabindex="0" @click="changeTabType('ViewCourse')"  @keypress="changeTabType('ViewCourse')">
                                        <span class="mdc-tab__content">
                                            <span class="mdc-tab__text-label font-m t-body2">{{$t('607')}}</span>
                                        </span>
                                        <span class="mdc-tab-indicator mdc-tab-indicator--active">
                                            <span
                                                class="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
                                        </span>
                                        <span class="mdc-tab__ripple"></span>
                                    </button>

                                    <button class="mdc-tab" role="tab" @click="changeTabType('ViewLesson')" @keypress="changeTabType('ViewLesson')" tabindex="0">
                                        <span class="mdc-tab__content">
                                            <span class="mdc-tab__text-label font-m t-body2">{{$t('608')}}</span>
                                        </span>
                                        <span class="mdc-tab-indicator ">
                                            <span
                                                class="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
                                        </span>
                                        <span class="mdc-tab__ripple"></span>
                                    </button>

                                    <button class="mdc-tab " role="tab" @click="changeTabType('ViewReward')" @keypress="changeTabType('ViewReward')" tabindex="0">
                                        <span class="mdc-tab__content">
                                            <span class="mdc-tab__text-label font-m t-body2">{{$t('609')}}</span>
                                        </span>
                                        <span class="mdc-tab-indicator ">
                                            <span
                                                class="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
                                        </span>
                                        <span class="mdc-tab__ripple"></span>
                                    </button>

                                    <button class="mdc-tab" role="tab" @click="changeTabType('ViewCertification')" @keypress="changeTabType('ViewCertification')" tabindex="0">
                                        <span class="mdc-tab__content">
                                            <span class="mdc-tab__text-label font-m t-body2">{{$t('610')}}</span>
                                        </span>
                                        <span class="mdc-tab-indicator ">
                                            <span
                                                class="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
                                        </span>
                                        <span class="mdc-tab__ripple"></span>
                                    </button>

                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="divider divider-subtabs"></div>
                </div>

         

   
    
</template>

<script>
/**
 * 차수 상세 탭 컴포넌트(degree view tab component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCTabBar} from '@material/tab-bar'

export default {
    props: ['setTabFixed'],
    data() {
        return {
            degreeViewTab: null,
            tabType: 'ViewCourse',
        }
    },

    mounted() {
        this.degreeViewTab = new MDCTabBar(this.$refs.degreeViewTab)
        if(typeof(this.$route.query.tabType) !='undefined'){
            this.tabType = this.$route.query.tabType
            this.degreeViewTab.activateTab(2)
            this.changeTabType(this.tabType)
        }  
    },

    updated() {
        this.degreeViewTab = new MDCTabBar(this.$refs.degreeViewTab)
        if (this.tabType === 'ViewCourse') {
            this.degreeViewTab.activateTab(0)
        }else if (this.tabType === 'ViewLesson') {
            this.degreeViewTab.activateTab(1)
        }else if (this.tabType === 'ViewReward') {
            this.degreeViewTab.activateTab(2)
        }else if (this.tabType === 'ViewCertification') {
            this.degreeViewTab.activateTab(3)
        }else {
            this.degreeViewTab.activateTab(0)
        }
    },

    computed: {
       isTabType() {
           return this.tabType
       }
    },

    methods: {
        changeTabType(type) {
            this.tabType = type
            this.$emit('setSubTab', type)
        }
        
    }
}
</script>
<style scoped>
/* .mdc-tab .mdc-tab__text-label {
     color: var(--ContentBG) !important;
}
.degree-detail-tab .mdc-tab-indicator > .mdc-tab-indicator__content--underline {
    background-color: var(--ContentBG)!important;
} */
</style>